import React from 'react';
import { Link } from "react-router-dom";
import './GlobalNav.scss';

const GlobalNav = (props) => 
    <div class="GlobalNav">
        <nav>
            <ul>
                <li><Link to="/">Browse</Link></li>
                <li><Link to="/gifmaker/">Create <span>Your Own</span></Link></li>
                <li><Link to="/about/">About</Link></li>
            </ul>
        </nav>
    </div>

export default GlobalNav;